"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardMetricIds = exports.StandardMetricPropertyNames = exports.PerformanceCounterMetricNames = exports.HISTOGRAM_AGGREGATION_MAP = exports.APPLICATION_INSIGHTS_NO_STANDARD_METRICS = void 0;
const sdk_metrics_1 = require("@opentelemetry/sdk-metrics");
/**
 * Disable Standard Metrics environment variable name.
 */
exports.APPLICATION_INSIGHTS_NO_STANDARD_METRICS = "APPLICATION_INSIGHTS_NO_STANDARD_METRICS";
/**
 * Mapping of OTEL_EXPORTER_OTLP_METRICS_DEFAULT_HISTOGRAM_AGGREGATION values to aggregation options.
 */
exports.HISTOGRAM_AGGREGATION_MAP = {
    explicit_bucket_histogram: { type: sdk_metrics_1.AggregationType.EXPLICIT_BUCKET_HISTOGRAM },
    base2_exponential_bucket_histogram: { type: sdk_metrics_1.AggregationType.EXPONENTIAL_HISTOGRAM },
};
var PerformanceCounterMetricNames;
(function (PerformanceCounterMetricNames) {
    PerformanceCounterMetricNames["PRIVATE_BYTES"] = "Private_Bytes";
    PerformanceCounterMetricNames["AVAILABLE_BYTES"] = "Available_Bytes";
    PerformanceCounterMetricNames["PROCESSOR_TIME"] = "Processor_Time";
    PerformanceCounterMetricNames["PROCESS_TIME_STANDARD"] = "Process_Time_Standard";
    PerformanceCounterMetricNames["REQUEST_RATE"] = "Request_Rate";
    PerformanceCounterMetricNames["REQUEST_DURATION"] = "Request_Execution_Time";
    PerformanceCounterMetricNames["PROCESS_TIME_NORMALIZED"] = "Process_Time_Normalized";
    PerformanceCounterMetricNames["EXCEPTION_RATE"] = "Exception_Rate";
})(PerformanceCounterMetricNames || (exports.PerformanceCounterMetricNames = PerformanceCounterMetricNames = {}));
exports.StandardMetricPropertyNames = {
    cloudRoleInstance: "cloud/roleInstance",
    cloudRoleName: "cloud/roleName",
    operationSynthetic: "operation/synthetic",
    requestSuccess: "Request.Success",
    requestResultCode: "request/resultCode",
    dependencyType: "Dependency.Type",
    dependencyTarget: "dependency/target",
    dependencySuccess: "Dependency.Success",
    dependencyResultCode: "dependency/resultCode",
    traceSeverityLevel: "trace/severityLevel",
    metricId: "_MS.MetricId",
    IsAutocollected: "_MS.IsAutocollected",
};
var StandardMetricIds;
(function (StandardMetricIds) {
    StandardMetricIds["REQUEST_DURATION"] = "requests/duration";
    StandardMetricIds["DEPENDENCIES_DURATION"] = "dependencies/duration";
    StandardMetricIds["EXCEPTIONS_COUNT"] = "exceptions/count";
    StandardMetricIds["TRACES_COUNT"] = "traces/count";
})(StandardMetricIds || (exports.StandardMetricIds = StandardMetricIds = {}));
//# sourceMappingURL=types.js.map